export const borderSizeMap = {
	"thin": 1,
	"hair": 1,
	"dotted": 1,
	"dashed": 1,
	"dashDot": 1,
	"dashDotDot": 1,
	"medium": 2,
	"mediumDashed": 2,
	"mediumDashDot": 2,
	"mediumDashDotDot": 2,
	"slantDashDot": 2,
	"thick": 3,
	"double": 3
};

export const borderTemplates = {
	// regular borders
	hair: (pos, color, zoom) => `${pos}: ${borderSizeMap.hair * zoom}px dotted ${color} !important;`,
	dotted: (pos, color, zoom) => `${pos}: ${borderSizeMap.dotted * zoom}px dashed ${color} !important;`,
	double: (pos, color, zoom) => `${pos}: ${borderSizeMap.double * zoom}px double ${color} !important;`,
	thin: (pos, color, zoom) => `${pos}: ${borderSizeMap.thin * zoom}px solid ${color} !important;`,
	medium: (pos, color, zoom) => `${pos}: ${borderSizeMap.medium * zoom}px solid ${color} !important;`,
	thick: (pos, color, zoom) => `${pos}: ${borderSizeMap.thick * zoom}px solid ${color} !important;`,
	// border-image based borders
	dashed: (pos, color, zoom, angle) => `
		${pos}: ${borderSizeMap.dashed * zoom}px solid transparent !important;
		border-image: repeating-linear-gradient(${angle}deg, 
			${color} 0px, ${color} ${5 * zoom}px, 
			transparent ${5 * zoom}px, transparent ${8 * zoom}px) 1 !important;`,
	dashDot: (pos, color, zoom, angle) => `
		${pos}: ${borderSizeMap.dashDot * zoom}px solid transparent !important;
		border-image: repeating-linear-gradient(${angle}deg, 
			${color} 0px, ${color} ${8 * zoom}px, 
			transparent ${8 * zoom}px, transparent ${11 * zoom}px, 
			${color} ${11 * zoom}px, ${color} ${14 * zoom}px, 
			transparent ${14 * zoom}px, transparent ${17 * zoom}px) 1 !important;`,
	dashDotDot: (pos, color, zoom, angle) => `
		${pos}: ${borderSizeMap.dashDotDot * zoom}px solid transparent !important;
		border-image: repeating-linear-gradient(${angle}deg, 
			${color} 0px, ${color} ${9 * zoom}px, 
			transparent ${9 * zoom}px, transparent ${11 * zoom}px, 
			${color} ${11 * zoom}px, ${color} ${14 * zoom}px, 
			transparent ${14 * zoom}px, transparent ${16 * zoom}px, 
			${color} ${16 * zoom}px, ${color} ${19 * zoom}px, 
			transparent ${19 * zoom}px, transparent ${22 * zoom}px) 1 !important;`,
	mediumDashed: (pos, color, zoom, angle) => `
		${pos}: ${borderSizeMap.mediumDashed * zoom}px solid transparent !important;
		border-image: repeating-linear-gradient(${angle}deg, 
			${color} 0px, ${color} ${6 * zoom}px, 
			transparent ${6 * zoom}px, transparent ${10 * zoom}px) 1 !important;`,
	mediumDashDot: (pos, color, zoom, angle) => `
		${pos}: ${borderSizeMap.mediumDashDot * zoom}px solid transparent !important;
		border-image: repeating-linear-gradient(${angle}deg, 
			${color} 0px, ${color} ${11 * zoom}px, 
			transparent ${11 * zoom}px, transparent ${15 * zoom}px, 
			${color} ${15 * zoom}px, ${color} ${18 * zoom}px, 
			transparent ${18 * zoom}px, transparent ${22 * zoom}px) 1 !important;`,
	mediumDashDotDot: (pos, color, zoom, angle) => `
		${pos}: ${borderSizeMap.mediumDashDotDot * zoom}px solid transparent !important;
		border-image: repeating-linear-gradient(${angle}deg, 
			${color} 0px, ${color} ${11 * zoom}px, 
			transparent ${11 * zoom}px, transparent ${15 * zoom}px, 
			${color} ${15 * zoom}px, ${color} ${18 * zoom}px, 
			transparent ${18 * zoom}px, transparent ${20 * zoom}px, 
			${color} ${20 * zoom}px, ${color} ${23 * zoom}px, 
			transparent ${23 * zoom}px, transparent ${27 * zoom}px) 1 !important;`,
	slantDashDot: (pos, color, zoom) => `
		${pos}: ${borderSizeMap.slantDashDot * zoom}px solid transparent !important;
		border-image: repeating-linear-gradient(135deg, 
			${color} 0px, ${color} ${8 * zoom}px, 
			transparent ${8 * zoom}px, transparent ${9 * zoom}px, 
			${color} ${9 * zoom}px, ${color} ${12 * zoom}px, 
			transparent ${12 * zoom}px, transparent ${13 * zoom}px) 1 !important;`
};

export const oppositeBordersMap = {
	"border-left": ["border-top", "border-bottom"],
	"border-right": ["border-top", "border-bottom"],
	"border-top": ["border-left", "border-right"],
	"border-bottom": ["border-left", "border-right"]
};